import React from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { formatPrice, RUSTIK_MIN_CM_OPTIONS, RUSTIK_OLCU_TAMAMLAMA_OPTIONS, DEFAULT_RUSTIK_MIN_CM, DEFAULT_RUSTIK_OLCU_TAMAMLAMA } from '../../../../utils';
import { handleNumericKeyDown, customSelectStyles } from '../OrderFormUtils';

const RustikForm = ({
  newOrder,
  onFieldChange,
  isLoading,
  productItems,
  productOptions,
  handleProductSelect,
  adminSettings,
  handleAddAccessory,
  handleAccessoryChange,
  handleRemoveAccessory,
  handleAddRayOption,
  handleRayOptionChange,
  handleRemoveRayOption
}) => {
  return (
    <>
      <div className="form-group">
        <label>Oda Adı *</label>
        <input type="text" value={newOrder.roomName || ''} onChange={(e) => onFieldChange('roomName', e.target.value)} required disabled={isLoading} placeholder="Örn: Salon" />
      </div>

      <div className="form-group">
        <label>Ürün Adı *</label>
        <CreatableSelect
          options={productOptions}
          value={
            (productOptions && productItems) ? 
              productOptions.find(o => o.value === (productItems.find(p => p.name === newOrder.productName)?.id)) ||
              (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
            : (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
          }
          onChange={(option) => {
            if (!option) {
              onFieldChange('productName', '');
              onFieldChange('unitPrice', '');
            } else if (option.__isNew__) {
              onFieldChange('productName', option.value);
              onFieldChange('unitPrice', '');
            } else {
              handleProductSelect(option.value);
            }
          }}
          isDisabled={isLoading} isClearable isSearchable placeholder="Ürün seçin veya yazın..." noOptionsMessage={() => "Ürün bulunamadı"} formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`} styles={customSelectStyles}
        />
      </div>

      <div className="form-group">
        <label>Ürün Varyantı</label>
        <input
          type="text"
          value={newOrder.productVariant || ''}
          onChange={(e) => onFieldChange('productVariant', e.target.value)}
          disabled={isLoading}
          placeholder="Renk, desen vb. giriniz..."
        />
      </div>

      <div className="form-group">
        <label>Minimum Değer</label>
        <Select
          options={RUSTIK_MIN_CM_OPTIONS}
          value={RUSTIK_MIN_CM_OPTIONS.find(
            (o) => o.value === (newOrder.rustikMinCm || DEFAULT_RUSTIK_MIN_CM)
          )}
          onChange={(option) => onFieldChange('rustikMinCm', option?.value || DEFAULT_RUSTIK_MIN_CM)}
          isDisabled={isLoading}
          isSearchable={false}
          styles={customSelectStyles}
        />
      </div>

      <div className="form-group">
        <label>Ölçü Tamamlama</label>
        <Select
          options={RUSTIK_OLCU_TAMAMLAMA_OPTIONS}
          value={RUSTIK_OLCU_TAMAMLAMA_OPTIONS.find(
            (o) => o.value === (newOrder.rustikOlcuTamamlama || DEFAULT_RUSTIK_OLCU_TAMAMLAMA)
          )}
          onChange={(option) => onFieldChange('rustikOlcuTamamlama', option?.value || DEFAULT_RUSTIK_OLCU_TAMAMLAMA)}
          isDisabled={isLoading}
          isSearchable={false}
          styles={customSelectStyles}
        />
      </div>

      <div className="form-group">
        <label>En (cm) *</label>
        <input type="number" step="0.01" value={newOrder.width || ''} onKeyDown={handleNumericKeyDown} onChange={(e) => onFieldChange('width', e.target.value)} required disabled={isLoading} />
      </div>

      <div className="form-group">
        <label>Kullanılan Cm</label>
        <input type="text" value={newOrder.usedM2 || ''} readOnly className="readonly-field" />
      </div>

      <div className="form-group">
        <label>Birim Fiyat (₺) *</label>
        <input
          type="number"
          step="0.01"
          min="0.01"
          value={newOrder.unitPrice || ''}
          onChange={(e) => onFieldChange('unitPrice', e.target.value)}
          required
          disabled={isLoading}
        />
      </div>

      <div className="form-group">
        <label>Ayak Modeli *</label>
        <Select
          options={(adminSettings?.rustikAyakModelList || []).map(v => ({ value: v, label: v }))}
          value={newOrder.ayakModel ? { value: newOrder.ayakModel, label: newOrder.ayakModel } : null}
          onChange={(option) => onFieldChange('ayakModel', option ? option.value : '')}
          isDisabled={isLoading} isClearable isSearchable placeholder="Seçiniz..." styles={customSelectStyles}
        />
      </div>

      <div className="form-group">
        <label>Ayak Çapı *</label>
        <Select
          options={(adminSettings?.rustikAyakCapList || []).map(v => ({ value: v, label: v }))}
          value={newOrder.ayakCap ? { value: newOrder.ayakCap, label: newOrder.ayakCap } : null}
          onChange={(option) => onFieldChange('ayakCap', option ? option.value : '')}
          isDisabled={isLoading} isClearable isSearchable placeholder="Seçiniz..." styles={customSelectStyles}
        />
      </div>

      <div className="form-group">
        <label>Ayak Uzunluğu *</label>
        <Select
          options={(adminSettings?.rustikAyakUzunlukList || []).map(v => ({ value: v, label: v }))}
          value={newOrder.ayakUzunluk ? { value: newOrder.ayakUzunluk, label: newOrder.ayakUzunluk } : null}
          onChange={(option) => onFieldChange('ayakUzunluk', option ? option.value : '')}
          isDisabled={isLoading} isClearable isSearchable placeholder="Seçiniz..." styles={customSelectStyles}
        />
      </div>

      <div className="form-group">
        <label>Renk Kodu *</label>
        <Select
          options={(adminSettings?.rustikAyakRenkKoduList || []).map(v => ({ value: v, label: v }))}
          value={newOrder.ayakRenkKodu ? { value: newOrder.ayakRenkKodu, label: newOrder.ayakRenkKodu } : null}
          onChange={(option) => onFieldChange('ayakRenkKodu', option ? option.value : '')}
          isDisabled={isLoading} isClearable isSearchable placeholder="Seçiniz..." styles={customSelectStyles}
        />
      </div>

      <div className="form-group">
        <label>Ayak Sayısı *</label>
        <Select
          options={[2,3,4,5,6,7,8,9,10].map(v => ({ value: v, label: v }))}
          value={newOrder.ayakAdeti ? { value: newOrder.ayakAdeti, label: newOrder.ayakAdeti } : null}
          onChange={(option) => onFieldChange('ayakAdeti', option ? option.value : '')}
          isDisabled={isLoading} isClearable isSearchable placeholder="Select..." styles={customSelectStyles}
        />
      </div>

      <div className="form-group">
        <label>Ek Ayak Sayısı</label>
        <Select
          options={[1,2,3,4,5].map(v => ({ value: v, label: v }))}
          value={newOrder.ekAyakSayisi ? { value: newOrder.ekAyakSayisi, label: newOrder.ekAyakSayisi } : null}
          onChange={(option) => onFieldChange('ekAyakSayisi', option ? option.value : '')}
          isDisabled={isLoading} isClearable isSearchable placeholder="Select..." styles={customSelectStyles}
        />
      </div>

      {newOrder.ekAyakSayisi > 0 && (
        <div className="form-group">
          <label>Ayak Ücreti (₺)</label>
          <input type="number" step="0.01" value={newOrder.ayakUcreti || ''} onChange={(e) => onFieldChange('ayakUcreti', e.target.value)} disabled={isLoading} />
        </div>
      )}

      <div className="form-group">
        <label>Montaj (₺)</label>
        <input type="number" step="0.01" value={newOrder.mounting || ''} onChange={(e) => onFieldChange('mounting', e.target.value)} disabled={isLoading} />
      </div>

      {/* Ray Seçenekleri Bölümü */}
      <div style={{ gridColumn: '1 / -1', marginTop: '20px' }}>
        <div className="section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 15px', backgroundColor: '#f8fafc', borderRadius: '8px 8px 0 0', border: '1px solid #e2e8f0', borderBottom: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <i className="fas fa-layer-group" style={{ color: '#0f172a' }}></i>
            <h4 style={{ margin: 0, fontSize: '14px', fontWeight: '600', color: '#1e293b' }}>Ray Seçenekleri</h4>
          </div>
          <button
            type="button"
            onClick={handleAddRayOption}
            style={{ display: 'flex', alignItems: 'center', gap: '5px', padding: '6px 12px', backgroundColor: '#0f172a', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}
          >
            <i className="fas fa-plus"></i> Seçenek Ekle
          </button>
        </div>
        <div className="section-body" style={{ padding: '15px', border: '1px solid #e2e8f0', borderRadius: '0 0 8px 8px', backgroundColor: '#fff', marginBottom: '20px' }}>
          {(!newOrder.rayOptions || newOrder.rayOptions.length === 0) ? (
            <div style={{ textAlign: 'center', padding: '20px', color: '#64748b', fontSize: '13px' }}>Henüz ray seçeneği eklenmemiş.</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {newOrder.rayOptions.map((opt) => (
                <div key={opt.id} style={{ display: 'grid', gridTemplateColumns: '1fr 100px 80px 100px 40px', gap: '15px', alignItems: 'center', padding: '12px', backgroundColor: '#f1f5f9', borderRadius: '8px' }}>
                  <div className="form-group-mini">
                    <label style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px', display: 'block' }}>Seçenek Adı</label>
                    <input type="text" value={opt.name || ''} onChange={(e) => handleRayOptionChange(opt.id, 'name', e.target.value)} placeholder="Seçenek adı" style={{ width: '100%', padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }} />
                  </div>
                  <div className="form-group-mini">
                    <label style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px', display: 'block' }}>Fiyat (₺)</label>
                    <input type="number" value={opt.price || ''} onChange={(e) => handleRayOptionChange(opt.id, 'price', e.target.value)} placeholder="Fiyat" style={{ width: '100%', padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }} />
                  </div>
                  <div className="form-group-mini">
                    <label style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px', display: 'block' }}>En (cm)</label>
                    <input type="text" value={newOrder.width || ''} readOnly className="readonly-field" style={{ width: '100%', padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', backgroundColor: '#e2e8f0' }} />
                  </div>
                  <div className="form-group-mini">
                    <label style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px', display: 'block' }}>Tutar (₺)</label>
                    <input type="text" value={opt.total || '0.00'} readOnly className="readonly-field" style={{ width: '100%', padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', backgroundColor: '#e2e8f0' }} />
                  </div>
                  <button
                    type="button"
                    onClick={() => handleRemoveRayOption(opt.id)}
                    style={{ marginTop: '18px', padding: '8px', backgroundColor: '#fee2e2', color: '#ef4444', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Aksesuarlar Bölümü */}
      <div style={{ gridColumn: '1 / -1', marginBottom: '20px' }}>
        <div className="section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 15px', backgroundColor: '#f8fafc', borderRadius: '8px 8px 0 0', border: '1px solid #e2e8f0', borderBottom: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <i className="fas fa-tags" style={{ color: '#0f172a' }}></i>
            <h4 style={{ margin: 0, fontSize: '14px', fontWeight: '600', color: '#1e293b' }}>Aksesuarlar</h4>
          </div>
          <button
            type="button"
            onClick={handleAddAccessory}
            style={{ display: 'flex', alignItems: 'center', gap: '5px', padding: '6px 12px', backgroundColor: '#0f172a', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}
          >
            <i className="fas fa-plus"></i> Aksesuar Ekle
          </button>
        </div>
        <div className="section-body" style={{ padding: '15px', border: '1px solid #e2e8f0', borderRadius: '0 0 8px 8px', backgroundColor: '#fff' }}>
          {(!newOrder.accessories || newOrder.accessories.length === 0) ? (
            <div style={{ textAlign: 'center', padding: '20px', color: '#64748b', fontSize: '13px' }}>Henüz aksesuar eklenmemiş.</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {newOrder.accessories.map((acc) => (
                <div key={acc.id} style={{ display: 'grid', gridTemplateColumns: '1fr 100px 80px 100px 40px', gap: '15px', alignItems: 'center', padding: '12px', backgroundColor: '#f1f5f9', borderRadius: '8px' }}>
                  <div className="form-group-mini">
                    <label style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px', display: 'block' }}>Aksesuar Adı</label>
                    <input type="text" value={acc.name || ''} onChange={(e) => handleAccessoryChange(acc.id, 'name', e.target.value)} placeholder="Aksesuar adı" style={{ width: '100%', padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }} />
                  </div>
                  <div className="form-group-mini">
                    <label style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px', display: 'block' }}>Fiyat (₺)</label>
                    <input type="number" value={acc.price || ''} onChange={(e) => handleAccessoryChange(acc.id, 'price', e.target.value)} placeholder="Fiyat" style={{ width: '100%', padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }} />
                  </div>
                  <div className="form-group-mini">
                    <label style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px', display: 'block' }}>Adet</label>
                    <input type="number" value={acc.quantity || ''} min="1" onChange={(e) => handleAccessoryChange(acc.id, 'quantity', e.target.value)} placeholder="Adet" style={{ width: '100%', padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }} />
                  </div>
                  <div className="form-group-mini">
                    <label style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px', display: 'block' }}>Tutar (₺)</label>
                    <input type="text" value={acc.total || '0.00'} readOnly className="readonly-field" style={{ width: '100%', padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', backgroundColor: '#e2e8f0' }} />
                  </div>
                  <button
                    type="button"
                    onClick={() => handleRemoveAccessory(acc.id)}
                    style={{ marginTop: '18px', padding: '8px', backgroundColor: '#fee2e2', color: '#ef4444', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="form-group">
        <label>Adet *</label>
        <input
          type="number"
          min="1"
          value={newOrder.quantity || ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(e) => onFieldChange('quantity', e.target.value)}
          required
          disabled={isLoading}
          placeholder="Adet giriniz"
        />
      </div>

      <div className="form-group">
        <label>İskonto (%)</label>
        <input
          type="number"
          min="0"
          max="100"
          value={newOrder.discount || ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(e) => onFieldChange('discount', e.target.value)}
          disabled={isLoading}
        />
      </div>

      {newOrder.productName && (
        <div className="form-group">
          <label>Toplam Tutar (₺)</label>
          <input
            type="text"
            value={formatPrice(newOrder.totalPrice)}
            readOnly
            className="readonly-field total-price"
          />
        </div>
      )}

      {newOrder.discount > 0 && (
        <div className="form-group">
          <label>İndirimli Tutar (₺)</label>
          <input
            type="text"
            value={formatPrice(newOrder.discountedPrice)}
            readOnly
            className="readonly-field discounted-price"
          />
        </div>
      )}
    </>
  );
};

export default RustikForm;
